import { ModalidadGrupoTarifa, Tarifa } from "src/gql/schema"

export const getPrioridad = (tarifa: Tarifa) => {
    const mod = tarifa?.grupo_tarifa?.modalidad || ""
    return mod === ModalidadGrupoTarifa.Base ? 1 : mod === ModalidadGrupoTarifa.Temporada ? 2 : 3
}